import React from 'react'
import {Header, Table, Icon} from 'semantic-ui-react'

const PlayerList = ({heading, players, onSelect}) => {
    return (
        <Table unstackable celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>{heading}</Table.HeaderCell>
                    <Table.HeaderCell>
                        <Icon.Group size='large'>
                            <Icon name='beer'/>
                            <Icon corner name='hashtag'/>
                        </Icon.Group>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {players.map(player =>
                    <Table.Row key={player.id} onClick={() => onSelect(player)} style={{cursor: 'pointer'}}>
                        <Table.Cell>
                            <Header as='h4' content={player.name}/>
                        </Table.Cell>
                        <Table.Cell>{player.beerCount}</Table.Cell>
                    </Table.Row>
                )}
            </Table.Body>
        </Table>
    )
};

export default PlayerList



// WEBPACK FOOTER //
// ./src/Components/PlayerList.js